import React from 'react';
import { CTAButton } from './CTAButton';
import { Check, ShieldCheck, Sparkles } from 'lucide-react';
export function ProductRevealSection() {
  return <section className="py-16 md:py-24 bg-gradient-to-b from-rose-50 to-white overflow-hidden" data-id="element-267">
      <div className="container mx-auto px-4 md:px-6" data-id="element-268">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-269">
          <p className="text-red-600 font-bold tracking-wider uppercase mb-2" data-id="element-270">
            The Breakthrough
          </p>
          <h2 className="text-3xl md:text-5xl font-bold text-gray-900 mb-6 font-serif" data-id="element-271">
            Introducing Dentafix™ — The Simple Gel That Changed Everything
          </h2>
          <p className="text-xl text-gray-600" data-id="element-272">
            A revolutionary denture gel that locks dentures firmly in place —
            clean, precise, no embarrassment.
          </p>
        </div>

        <div className="relative bg-white rounded-3xl shadow-2xl overflow-hidden border border-gray-100" data-id="element-273">
          <div className="grid grid-cols-1 lg:grid-cols-2" data-id="element-274">
            {/* Product Image Area */}
            <div className="relative bg-gray-50 min-h-[400px] flex items-center justify-center p-8" data-id="element-275">
              <div className="absolute inset-0 opacity-10 bg-[radial-gradient(#dc2626_1px,transparent_1px)] [background-size:16px_16px]" data-id="element-276"></div>

              {/* Product Mockup */}
              <div className="relative z-10 w-64 h-80 bg-white rounded-xl shadow-2xl border border-gray-200 flex flex-col items-center p-6 transform hover:scale-105 transition-transform duration-500" data-id="element-277">
                <div className="w-full flex justify-between items-center mb-8" data-id="element-278">
                  <span className="font-bold text-red-600 text-xl" data-id="element-279">
                    Dentafix™
                  </span>
                  <div className="bg-red-100 text-red-800 text-xs font-bold px-2 py-1 rounded" data-id="element-280">
                    PRO
                  </div>
                </div>
                <div className="flex-1 w-full flex items-center justify-center" data-id="element-281">
                  <div className="w-32 h-32 bg-rose-100 rounded-full flex items-center justify-center opacity-80" data-id="element-282">
                    <div className="w-24 h-12 border-b-4 border-red-400 rounded-b-full" data-id="element-283"></div>
                  </div>
                </div>
                <div className="w-full mt-8" data-id="element-284">
                  <div className="h-2 bg-gray-100 rounded-full mb-2" data-id="element-285"></div>
                  <div className="h-2 bg-gray-100 rounded-full w-2/3" data-id="element-286"></div>
                </div>
                <div className="absolute -right-4 top-10 bg-amber-400 text-white font-bold px-3 py-1 rounded-l-md shadow-md" data-id="element-287">
                  New!
                </div>
              </div>

              {/* Decorative Elements */}
              <div className="absolute bottom-8 right-8 bg-white/90 backdrop-blur p-4 rounded-xl shadow-lg border border-gray-100" data-id="element-288">
                <div className="flex items-center gap-2" data-id="element-289">
                  <ShieldCheck className="text-green-500 w-5 h-5" data-id="element-290" />
                  <span className="font-semibold text-gray-800" data-id="element-291">
                    Clinical Strength
                  </span>
                </div>
              </div>
            </div>

            {/* Content Area */}
            <div className="p-8 md:p-12 flex flex-col justify-center" data-id="element-292">
              <h3 className="text-2xl font-bold text-gray-900 mb-6" data-id="element-293">
                Why Dentists Are Calling This "The Future of Denture Comfort"
              </h3>

              <ul className="space-y-4 mb-8" data-id="element-294">
                {['Holds securely for up to 3 days', 'Creates a soft, vacuum-like seal', 'Prevents gum soreness and irritation', 'Zero zinc, zero toxins, zero bad taste', 'Waterproof — eat and drink freely'].map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-295">
                    <div className="mt-1 bg-green-100 p-1 rounded-full" data-id="element-296">
                      <Check className="w-4 h-4 text-green-600" data-id="element-297" />
                    </div>
                    <span className="text-lg text-gray-700" data-id="element-298">{item}</span>
                  </li>)}
              </ul>

              <div className="flex flex-col sm:flex-row gap-4 items-center" data-id="element-299">
                <CTAButton text="Secure My Dentures Now" data-id="element-300" />
                <p className="text-sm text-gray-500 flex items-center gap-1" data-id="element-301">
                  <Sparkles className="w-4 h-4 text-amber-500" data-id="element-302" />
                  Selling fast today
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-12" data-id="element-303">
          <img src="https://images.unsplash.com/photo-1556909114-f6e7ad7d3136?w=800&q=80" alt="Confident senior couple" className="w-full h-64 md:h-80 object-cover rounded-2xl shadow-lg opacity-90 hover:opacity-100 transition-opacity" data-id="element-304" />
        </div>
      </div>
    </section>;
}